import Modal from '../_bootstrapModalExtensions';
import Classes from '../_classes';
import * as Url from '../Utils/UrlUtil';

export function SetAddresseeReceiveData(visibleIndex: number, addresseeReceiveMode: string, addresseeReceiveStatus: string, addresseeReceiveDate: string) {

    // TODO: This function is using internal functions, may break at anytime
    // First, specify the class of the grid, which is: MVCxClientGridView
    // The content update could be done 2 ways
    // - Force an update from server side (slow, but correct)
    // - Use the batchedit api (fast, client side only, not compatible with endless paging)
    // - Using internal functions or marking everything with a specific class or id (the current solution)
    //   - To do this, a unique fieldname should be added, but that is only supported with data templates (so the highlight/search features are disabled)
    // Here is a reminder to how to do it with the batchEdit api: grid.batchEditApi.SetCellValue(visibleIndex, "AddresseeReceiveMode", addresseeReceiveMode, addresseeReceiveMode, true);
    var grid = window["AddresseeListPartial"];

    // And this is the part which may break any time (GetRow is an internal method)
    var row = grid.GetRow(visibleIndex);

    // And this is where we try to find the specific columns (again, this structure is an implementation detail of the DX grid, might change in the future)
    row.getElementsByClassName('AddresseeReceiveModeCell')[0].innerText = addresseeReceiveMode;
    row.getElementsByClassName('AddresseeReceiveStatusCell')[0].innerText = addresseeReceiveStatus;
    row.getElementsByClassName('AddresseeReceiveDateCell')[0].innerText = addresseeReceiveDate;
}

export function OnProcessActionAddresseeListBeginCallback(s, e: MVCxClientBeginCallbackEventArgs) {
    let staticExportProperties = document.getElementById('export-postal-addressee') as HTMLInputElement;

    if (e.command === "EXPORT") {
        e.customArgs['exportProcessNumber'] = staticExportProperties.dataset.processnumber;
        e.customArgs['exportFilingNumber'] = staticExportProperties.dataset.filingnumber;
        e.customArgs['exportFilingSystemNumber'] = staticExportProperties.dataset.filingsystemnumber;
        e.customArgs['exportFilingClerkName'] = staticExportProperties.dataset.filingclerkname;
    }
}

export function OnProcessActionAddresseeListEndCallback(hasPostalAddressee: boolean) {
    let $exportButton: JQuery<HTMLButtonElement> = $('#export-postal-addressee');

    $exportButton.prop('disabled', !hasPostalAddressee);
    $exportButton.prop(
        'title',
        hasPostalAddressee ?
            "Postai kapcsolattartású címzettek exportálása (.xlsx formátumban)"
            : "Nincsen exportálandó adat");
}

export function EditAddresseeReceiveLink(id: number, isPartner: boolean, visibleIndex: number) {
    let modalSettings: Classes.BootstrapModalWithAjaxContentSettings = GetModalSettings();

    Modal.showBootstrapModalWithAjaxContent(modalSettings);

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        const contentUrlTemplate: string = window.ETDR_RD.appConfig["UrlTemplate.GetEditAddresseeReceiveForm"];
        const saveUrl: string = window.ETDR_RD.appConfig['UrlAction.UpdateAddresseeReceive'];

        settings.title = 'Átvételi adatok megadása';
        settings.contentUrl = Url.createUrlFromTemplate(contentUrlTemplate, { id: id, isPartner: isPartner, visileIndex: visibleIndex });
        settings.saveUrl = saveUrl;
        settings.callback = (data) => {
            SetAddresseeReceiveData(visibleIndex, data.addresseeReceiveMode, data.addresseeReceiveStatus, data.addresseeReceiveDate);
        };

        return settings;
    }
}

$(() => {
    $(document).on('click', '.edit-addressee-receive-link', (event: JQuery.TriggeredEvent) => {
        const $button: JQuery<HTMLElement> = $(event.target);
        const id = $button.data('id');
        const isPartner = $button.data('is-partner');
        const visibleIndex = $button.data('visible-index');

        EditAddresseeReceiveLink(id, isPartner, visibleIndex);
    });
});
